module.exports = __webpack_public_path__ + "static/media/eh-3.f8a51974.jpg";